const WorkEnvironmentSections = {
    MANAGER: 'manager',
    TEAM: 'team',
    ORGANISATION: 'organisation'
};

export default WorkEnvironmentSections;
